export const DEFAULT_ACCEPTED_IMAGE_FORMATS = '.jpg,.jpeg,.png,.webp,.svg'
